import { GenerateSignaturePacket } from '@/components/transactions-page/generateSignaturePacket-page';
import useRefresh from '@/hooks/use-refresh';
import { Helmet as Head } from 'react-helmet';

const GenerateSignaturePacketPage = () => {
  useRefresh();
  return (
    <>
      <Head>
        <title>Generate Signature Packet</title>
      </Head>
      <GenerateSignaturePacket />
    </>
  );
};

export default GenerateSignaturePacketPage;
